/**
 * Hermes 流式阶段：区分「模型思考」与「工具/改站执行」，
 * 供 Reasoning 冻结计时与状态条文案使用。
 */

export type HermesStreamPhase = "idle" | "thinking" | "tools" | "authoring";

/** 正在改站草稿（子 Agent / brand_site_authoring 事件） */
export const HERMES_AUTHORING_STATUS = "正在改站草稿…";

export function hermesStreamPhaseFromStatus(status: string | null | undefined): HermesStreamPhase {
  const s = status?.trim() ?? "";
  if (!s) return "idle";
  if (s === HERMES_AUTHORING_STATUS || s.includes("改站草稿") || s.includes("正在改站")) {
    return "authoring";
  }
  // 工具态：有具体「正在…」且不是纯思考占位
  if (
    s.startsWith("正在") &&
    !s.includes("思考") &&
    !s.includes("回复")
  ) {
    return "tools";
  }
  return "thinking";
}

/** Reasoning 是否仍处「本轮思考区块」开着（有 thinking、尚无正文） */
export function hermesReasoningShouldStream(
  isMessageStreaming: boolean,
  hasThinking: boolean,
  hasAnswer: boolean,
  _streamStatus?: string | null,
): boolean {
  return Boolean(isMessageStreaming && hasThinking && !hasAnswer);
}

/** 工具/改站执行中应暂停思考秒数累计 */
export function hermesReasoningTimerPaused(streamStatus: string | null | undefined): boolean {
  const phase = hermesStreamPhaseFromStatus(streamStatus);
  return phase === "tools" || phase === "authoring";
}
